// extracted by mini-css-extract-plugin
module.exports = {"scrollbarHide":"breed-segmentation-slider_scrollbarHide__L1Q8Z"};